import React from 'react';
import styled from 'styled-components';

interface FormSelectProps extends React.InputHTMLAttributes<HTMLSelectElement> {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: string[];
  placeholder?: string;
}


const FormSelect = ({ value, onChange, options, placeholder, ...rest }: FormSelectProps) => {
  return (
    <Select>
      <select value={value} onChange={onChange} {...rest}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt, i) => (
          <option key={i} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </Select>
    
  );
};

export default FormSelect;


const Select = styled.div`
  display: flex;
  padding: 0.5rem 0rem;

  select {
    width: 100%;
    padding: 0.6rem 0.8rem;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    color: #333;
    appearance: none;
    outline: none;

    &:focus {
      border-color: #E5605E;
      box-shadow: 0 0 0 2px rgba(229, 96, 94, 0.2);
    }
  }
`;


